import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'

class FacilitiesHolidayHours extends Component {
        constructor(props){
            super(props);

            this.state = {
                year: "",
                holidayOperatingHours: []
            };
        }

    componentDidMount() {
        this.fetchData()
    }

    fetchData = async () => {
        try {
            const response = await fetch("./content/global/contact/holidayHours.json");
            if (response.ok) {
                this.setState(await response.json());
            } else {
                throw response;
            }
        } catch (e) {
            console.log(e);
        }
    };

    render() {
        return (
            <div className="facilities-holiday-hours">
                <h4 className="facilities-holiday-hours__header">{`Customer CARE Center ${this.state.year} Holiday Schedule`}</h4>
                <table className="table__holiday-hours">
                    <tbody>
                        <tr>
                            <td className="table__body--holiday table__body--holiday-title"> Holiday Operating Hours </td>
                            <td className="table__body--holiday table__body--holiday-title"> </td>
                            <td className="table__body--holiday table__body--holiday-title"> </td>
                        </tr>
                        <tr>
                            <td className="table__body--holiday table__body--holiday-header"> </td>
                            <td className="table__body--holiday table__body--holiday-header"> Open </td>
                            <td className="table__body--holiday table__body--holiday-header"> Close </td>
                        </tr>
                    {
                        this.state.holidayOperatingHours.map( (holiday, index) => {
                            return (
                                <tr key={index}>
                                    <td className="table__body--holiday table__body--holiday-name">
                                        <div className="facilities-holiday-hours__name">
                                            {holiday.holidayName}
                                        </div>
                                        <div className="facilities-holiday-hours__date">
                                            {holiday.startDate}
                                            <br/>
                                            {holiday.endDate ? " to " + holiday.endDate : ""}
                                        </div>
                                    </td>
                                    <td className="table__body--holiday">
                                        {holiday.openingTime}
                                    </td>
                                    <td className="table__body--holiday">
                                        {holiday.closingTime}
                                    </td>
                                </tr>
                            )
                        })
                    }
                    </tbody>
                </table>
            </div>
        );
    }
}

export default withRouter(FacilitiesHolidayHours);




// WEBPACK FOOTER //
// ./src/components/FacilitiesHolidayHours/FacilitiesHolidayHours.js